export type SHOP_PARAMS = {
  shopType: string;
  countryCode: string;
};

export const SHOP_ROUTE = {
  name: 'shop/:shopType/:countryCode',
  route(params: SHOP_PARAMS): string[] {
    return ['/' + 'shop', params.shopType, params.countryCode];
  },
  DEFAULT: '',

  CART: {
    name: 'cart',
    route(params: SHOP_PARAMS): string[] {
      return [...SHOP_ROUTE.route(params), this.name];
    }
  },
  CHECKOUT: {
    name: 'checkout',
    route(params: SHOP_PARAMS): string[] {
      return [...SHOP_ROUTE.route(params), this.name];
    }
  },
  HOME: {
    name: 'home',
    route(params: SHOP_PARAMS): string[] {
      return [...SHOP_ROUTE.route(params), this.name];
    }
  },
  PRODUCT: {
    name: 'product/:productId',
    route(params: SHOP_PARAMS & { productId: string }): string[] {
      return [...SHOP_ROUTE.route(params), 'product', params.productId];
    }
  },
  REDEEM_CODE: {
    name: 'redeemcode',
    route(params: SHOP_PARAMS & { productId: string }): string[] {
      return [...SHOP_ROUTE.route(params), this.name];
    }
  }
};
